import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { HiBellAlert, HiShoppingCart } from "react-icons/hi2";
import { routes } from "../../../helper/routes";
import { useCart } from "../../../context/cart/CartContext";
import "./Header.css";
import "./ContentHeader.css";
import NotificationDropdown from "./NotificationDropdown";
import teacherImg from "../../../assets/images/teacher.png";
import studentImg from "../../../assets/images/student.png";
import parentImg from "../../../assets/images/parent.png";
import adminImg from "../../../assets/images/admin.png";
import config from "../../../helper/config";
import { customerConstants } from "../../../helper/constants.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

const ContentHeader = () => {
  const history = useHistory();
  const { cartItemCount } = useCart();
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isAdmin] = useState(sessionStorage.getItem("userType") === "admin");
  const [isTeacher] = useState(sessionStorage.getItem("userType") === "teacher");
  const [isStudent] = useState(sessionStorage.getItem("userType") === "student");
  const [isParent] = useState(sessionStorage.getItem("userType") === "parent");

  const headerLabelMaker = () => {
    const sessionUserName = sessionStorage.getItem("username");

    if (sessionUserName) {
      const names = sessionUserName.split(" ");
      const initials = names.map((name) => {
        if (name.length > 0) {
          return name[0].toUpperCase();
        } else {
          return "";
        }
      });
      return initials.join("");
    } else {
      return "";
    }
  };

  const toggleNotifications = () => {
    setIsNotificationOpen(!isNotificationOpen);
  };

  const goToCart = () => {
    history.push(routes.my_cart);
  };

  const goToProfile = () => {
    history.push(routes.profile);
  };

  const customer = getCustomerFeatureFlag();
  let logoStyle;
  switch (customer) {
    case customerConstants.EXO_CUSTOMER1:
    case customerConstants.EXO_CUSTOMER2:
      logoStyle = { width: "140px", height: "auto" };
      break;
    case customerConstants.EDF_CUSTOMER2:
    case customerConstants.EDF_CUSTOMER3:
      logoStyle = { width: "40px", height: "auto" };
      break;
    default:
      logoStyle = { width: "140px", height: "auto" };
      break;
  }

  return (
    <div className="content-header">
      {/* Left side: Usertype Logo */}
      <div className="content-header-left">
        {isTeacher && (
          <img
            alt="Teacher Logo"
            className="logo usertype-logo usertype-logo-teacher"
            src={teacherImg}
            style={logoStyle}
          />
        )}
        {isStudent && (
          <img
            alt="Student Logo"
            className="logo usertype-logo usertype-logo-student"
            src={studentImg}
            style={logoStyle}
          />
        )}
        {isParent && (
          <img
            alt="Parent Logo"
            className="logo usertype-logo usertype-logo-parent"
            src={parentImg}
            style={logoStyle}
          />
        )}
        {isAdmin && (
          <img
            alt="Admin Logo"
            className="logo usertype-logo usertype-logo-admin"
            src={adminImg}
            style={logoStyle}
          />
        )}
      </div>

      {/* Right side: Topbar controls */}
      <div className="topbar" style={{ position: "relative" }}>
        {!isTeacher && !isAdmin && (
          <div className="topbar-item">
            <div
              className="btn btn-icon btn-clean d-flex align-items-center btn-lg px-2 mr-2 cart-icon"
              id="kt_quick_cart_toggle"
              onClick={goToCart}
              style={{ cursor: "pointer" }}
            >
              <HiShoppingCart className="topbar-icon cart-icon__icon" />
              {cartItemCount > 0 && (
                <span className="cart-badge">{cartItemCount > 99 ? "99+" : cartItemCount}</span>
              )}
            </div>
          </div>
        )}

        <div className="topbar-item">
          <div
            className="btn btn-icon btn-clean d-flex align-items-center btn-lg px-2 mr-2 notification-icon"
            id="kt_quick_notifications_toggle"
            onClick={toggleNotifications}
            style={{ cursor: "pointer" }}
          >
            <HiBellAlert className="topbar-icon notification-icon__icon" />
          </div>
        </div>

        <NotificationDropdown
          isOpen={isNotificationOpen}
          onClose={() => setIsNotificationOpen(false)}
        />

        <div className="topbar-item">
          <div
            className="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2 profile-icon"
            id="kt_quick_user_toggle"
            onClick={goToProfile}
            style={{ cursor: "pointer" }}
          >
            <span className="symbol symbol-35 symbol-primary profile-symbol">
              <span className="symbol-label font-size-h5 font-weight-bold">
                {headerLabelMaker()}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentHeader;
